import { render } from "./ScrollTop.vue?vue&type=template&id=3c79646a"
import script from "./ScrollTop.vue?vue&type=script&lang=js"
export * from "./ScrollTop.vue?vue&type=script&lang=js"

import "./ScrollTop.vue?vue&type=style&index=0&id=3c79646a&lang=css"
script.render = render

export default script